export const SET_DEFAULT_BILLING_ADDRESS_REQUESTED = 'SET_DEFAULT_BILLING_ADDRESS_REQUESTED';
export const SET_DEFAULT_BILLING_ADDRESS_SUCCEEDED = 'SET_DEFAULT_BILLING_ADDRESS_SUCCEEDED';
export const SET_DEFAULT_ADDRESS_REQUESTED = 'SET_DEFAULT_ADDRESS_REQUESTED';
export const SET_DEFAULT_ADDRESS_SUCCEEDED = 'SET_DEFAULT_ADDRESS_SUCCEEDED';

